export const DASHBOARD_RESET = 'DASHBOARD_RESET';

export const resetDashboard = () => async (dispatch) => {
  dispatch({ type: DASHBOARD_RESET });
};
